export default __webpack_public_path__ + "static/media/10-INT-(4-3).d75dce80.jpg";